<template>
  <v-snackbar
    v-model="show"
    color="water"
    variant="flat"
    :timeout="timeout"
    :offset="200"
    @timeout="hideSnackbar"
  >
    {{ message }}
    <template v-slot:actions>
      <v-btn
        color="pink"
        variant="text"
        @click="hideSnackbar"
        :to="{ name: 'cart' }"
        class="snackbar-button"
      >
        <v-icon>mdi-cart</v-icon>
        カートを見る
      </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue'
import store from '@/store'
import { SnackbarState } from '@/store/modules/snackbar';

const show = ref(false)
const timeout = ref(3000)
const message = ref('')

watch(store.state.snackbar, (snackbar: SnackbarState) => {
  console.log('snackbar')
  show.value = false
  if (snackbar.visible && !!snackbar.message) {
    message.value = snackbar.message
    show.value = true
  }
})

watch(show, (value: boolean) => {
  if (!value) {
    hideSnackbar()
  }
})

const hideSnackbar = () => {
  store.dispatch('snackbar/hide')
}

</script>

<style lang="scss" scoped>
.v-snackbar {
  &::v-deep(.v-snackbar__wrapper) {
    color: white;
    border: 4px solid black;
    border-radius: 10px;
  }
  &::v-deep(.v-snackbar__content) {
    color: white;
    font-size: 1.2rem;
    font-weight: bold;
  }
  .snackbar-button {
    &::v-deep(.v-btn__content) {
      color: white;
    }
  }
}
</style>
